module.exports = __webpack_public_path__ + "static/media/3.97a6b9bb.jpg";